import { render, staticRenderFns } from "./FavoriteItem.vue?vue&type=template&id=a5463af4&scoped=true"
import script from "./FavoriteItem.vue?vue&type=script&lang=js"
export * from "./FavoriteItem.vue?vue&type=script&lang=js"
import style0 from "./FavoriteItem.vue?vue&type=style&index=0&id=a5463af4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5463af4",
  null
  
)

export default component.exports